import { TemplateElement, html, defineElement } from '@webtides/element-js';
import '../icon/icon.js';
import style from './page-legend-cards.css';

/**
 * @property {array} cards
 */
export default class PageLegendCards extends TemplateElement {
    constructor() {
        super({ styles: [style] });
    }

    properties() {
        return {
            cards: [],
        };
    }

    template() {
        return html`
            ${this.cards.map(
                (card) => html`
                    <a href="#${card.slug}" class="p-16 rounded-md bg-green-light25">
                        <div class="h4 mb-8">${card.kicker}</div>
                        <div class="text-gray-50">${card.headline}</div>
                    </a>
                `,
            )}
        `;
    }
}

defineElement('mb-page-legend-cards', PageLegendCards);
